import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import * as React from "react";
import { Outlet } from "react-router-dom";
import useResponsive from "../../hooks/useResponsive";

const OnboardingLayout: React.FC = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        minHeight: "100vh",
        overflowY: 'auto',
        backgroundColor: theme.palette.common.white,
      }}
    >
      <Outlet />
    </Box>
  );
};
export default OnboardingLayout;
